import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

type Props = {
	className?: string;
};

export function SkeletonCard(props: Props) {
	return (
		<div className={cn('flex flex-col space-y-3', props.className)}>
			<Skeleton className="h-[225px] w-full rounded-xl" />
			<div className="space-y-2 w-full">
				<Skeleton className="h-4 w-2/3" />
				<Skeleton className="h-4 w-1/2" />
				<Skeleton className="h-4 w-1/3" />
			</div>
		</div>
	);
}
